import React, { useState, useEffect, useRef, useReducer } from "react";
import {
  CategoryForm,
  FlatType,
  priceList,
  slots,
} from "../../utils/categoryForm";
import "./styles.css";
import Dropdown from "../dropDown";
import * as ReactIcons from "react-icons/fa";
import { IconContext } from "react-icons";
import { verifyPincode } from "../../utils/pinCodeVerification";
import CategoryDetailDropdown from "../categoryDetailDropdown";
import FlatDropdown from "../dropDown/flatDropDown";
import SlotDropdown from "../dropDown/slotDropDown";
import { placeOrder } from "../../utils/placeOrder";
import { confirm } from "../../assets/images";

const Modal = ({ selectedCategory, closeModal }) => {
  const [formOptions, setFormOptions] = useState(
    CategoryForm(selectedCategory)
  );
  const [priceDetails, setPriceDetails] = useState({});
  const [availabileSlots, setAvailableSlots] = useState([]);
  const [userSelectedCategory, setUserSelectedCategory] = useState({
    MainCategory: selectedCategory,
    SubCategory: "",
    subCategoryDetails: "",
    flatType: "",
    Qty: "",
    selectedSlot: "",
    addOns: "",
  });
  const [currentSection, setCurrentSection] = useState("personal-section"); // possible values -> personal section, job section, slot section, confirm section
  const [validationError, setValidationError] = useState({
    nameError: false,
    phoneNumberError: false,
    EmailaddressError: false,
    jobTypeError: false,
    pincodeError: false,
    selectedCategoryError: false,
    subCategoryError: false,
    subCategoryDetailsError: false,
    addOnsError: false,
    flatTypeError: false,
    QtyError: false,
    selectedSlotError: false,
  });
  const [validatePersonalDetailsError, setValidatePersonalDetailsError] =
    useState(false);
  const [validateJobDetailsError, setValidateJobDetailsError] = useState(false);
  const [showOrderPlaced, setShowOrderPlaced] = useState(false);

  const [personalData, setPersonalData] = useState({
    fulllName: "",
    phoneNumber: "",
    Emailaddress: "",
    pincode: "",
    homeAddress: "",
  });

  //creating refs for different dropdowns
  const modalRef = useRef();
  const dropDownRef = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPersonalData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      closeModal();
    }
  };

  const validatePhoneNumber = (value) => {
    const numericRegex = /^[0-9]{10}$/;

    if (value.length === 0) {
      return false;
    } else if (!numericRegex.test(value)) {
      return false;
    } else {
      return true;
    }
  };

  const validatePersonalData = () => {
    if (validationError.pincodeError) {
      alert("Sorry, we are currently not serving your locality!");
      //add modal close on then
    } else {
      const isPhoneNumber = validatePhoneNumber(personalData.phoneNumber);
      if (!isPhoneNumber) {
        setValidationError({ ...validationError, phoneNumberError: true });
      } else {
        setValidationError({ ...validationError, phoneNumberError: false });
      }

      if (personalData.fulllName.length < 3) {
        setValidationError({ ...validationError, nameError: true });
      } else {
        setValidationError({ ...validationError, nameError: false });
      }

      if (personalData.Emailaddress.length < 7) {
        setValidationError({ ...validationError, EmailaddressError: true });
      } else {
        setValidationError({ ...validationError, EmailaddressError: false });
      }
      if (
        validationError.nameError === true ||
        validationError.phoneNumberError === true ||
        validationError.EmailaddressError === true
      ) {
        setValidatePersonalDetailsError(true);
      } else {
        setValidatePersonalDetailsError(false);
        if (
          userSelectedCategory?.MainCategory === "Carpenter Services" ||
          userSelectedCategory?.MainCategory === "Plumbing" ||
          userSelectedCategory?.MainCategory === "Electrician"
        ) {
          setCurrentSection("slot-section");
        } else setCurrentSection("job-section");
      }
    }
  };

  //validate the Job Section
  const validateJobSection = () => {
    if (
      userSelectedCategory?.MainCategory === undefined ||
      userSelectedCategory?.MainCategory === null
    ) {
      setValidationError({ ...validationError, selectedCategoryError: true });
    } else {
      setValidationError({ ...validationError, selectedCategoryError: false });
    }

    if (
      userSelectedCategory?.SubCategory === undefined ||
      userSelectedCategory?.SubCategory?.length < 1
    ) {
      setValidationError({ ...validationError, subCategoryError: true });
    } else {
      setValidationError({ ...validationError, subCategoryError: false });
    }

    if (
      validationError.selectedCategoryError ||
      validationError.subCategoryError
    ) {
      setValidateJobDetailsError(true);
    } else {
      setValidateJobDetailsError(false);
      setCurrentSection("slot-section");
    }
  };

  const handleDropDownClickOutside = (event) => {
    if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
      closeDropDown();
    }
  };

  const closeDropDown = () => {
    dropDownRef.close();
  };

  const modelData = () => {
    const body = {
      user_details: personalData,
      job_details: userSelectedCategory,
      price_details: priceDetails,
    };

    placeOrder(body);
  };

  //fetches all available slots
  useEffect(() => {
    console.log("we are in price details useeffect line 187")
    if (
      (userSelectedCategory.MainCategory === "Cleaning" &&
        userSelectedCategory.SubCategory === "Full house cleaning" &&
        userSelectedCategory?.flatType?.length > 0) ||
      (userSelectedCategory.MainCategory === "Bathroom Cleaning" &&
        userSelectedCategory?.flatType?.length > 0)
    ) {
      const cleanPrice = priceList(
        userSelectedCategory?.MainCategory,
        userSelectedCategory?.SubCategory,
        userSelectedCategory?.subCategoryDetails,
        userSelectedCategory?.flatType
      );
      setPriceDetails({
        price: cleanPrice.price,
        tax: cleanPrice?.tax,
        total: cleanPrice?.total,
      });
    } else if (
      userSelectedCategory?.MainCategory === "Sofa Cleaning" ||
      (userSelectedCategory?.MainCategory === "Cleaning" &&
        userSelectedCategory?.SubCategory === "Kitchen cleaning")
    ) {
      console.log("we are in else if 212");
      const details = CategoryForm(userSelectedCategory?.MainCategory);
      const price = details?.SubCategory?.filter(
        (item) => item.subCategoryName === userSelectedCategory?.SubCategory
      );
      if (userSelectedCategory?.MainCategory === "Sofa Cleaning") {
        console.log("sofa cleaning price", price);
        setPriceDetails({
          price: price[0]?.price,
          tax: price[0]?.tax,
          total: price[0]?.total,
        });
      } else {
        // setPriceDetails({
        //   price: price[0]?.price,
        //   tax: price[0]?.tax,
        //   total: price[0]?.total
        // })
        let item = details?.SubCategory?.filter(
          (item) => item?.subCategoryName === "Kitchen cleaning"
        );
        console.log("in 233", item)
        console.log(
          "just trying",
          item.map((unit) =>
            unit?.subCategoryDetails?.map(
              (item) => item?.subCategoryDetailsName
            )
          )
        );

        console.log("user selected category in useeffect price ", userSelectedCategory?.subCategoryDetails)
        item = item.map(
          (unit) =>
            unit?.subCategoryDetails?.filter(item => item?.subCategoryDetailsName === userSelectedCategory?.subCategoryDetails)
            
        );
       
        console.log(" final item is ", item)
        setPriceDetails({
          price: item[0][0]?.price,
          tax: item[0][0]?.tax,
          total: item[0][0]?.total,
        });
          

      }
    }
  }, [userSelectedCategory]);

  //fetches all available slots
  useEffect(() => {
    const returnSlot = slots(userSelectedCategory?.MainCategory);
    setAvailableSlots(returnSlot);
  }, [userSelectedCategory?.MainCategory]);

  //click listener for dropdown
  useEffect(() => {
    document.addEventListener("mousedown", handleDropDownClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleDropDownClickOutside);
  }, []);

  const IconComponent = ReactIcons["FaArrowRight"];
  const BackIcon = ReactIcons["FaArrowLeft"];

  //click listener
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="mdoal-container">
      {/* step 1 : user data  */}
      {currentSection === "job-section" ? (
        <section className="modal-main" ref={modalRef}>
          {console.log('user selected cate', userSelectedCategory)}
          {/* subcategories */}
          <div className="modal-header">
            <p>Help us with the following details</p>
          </div>
          {/* only if there is a drop down */}
          {/* { formOptions?.subCategory ?  */}
          <>
            <div className="form-container">
              <div>
                <p> What can we help you with ? </p>
              </div>

              <div className="subcategory-dropDown">
                <Dropdown
                  data={formOptions?.SubCategory}
                  setUserSubCategory={(value) => {
                    setUserSelectedCategory({
                      ...userSelectedCategory,
                      SubCategory: value,
                    });
                  }}
                  value={userSelectedCategory?.SubCategory}
                />
              </div>
            </div>
            <div>
              {userSelectedCategory.MainCategory === "Cleaning" &&
              userSelectedCategory?.SubCategory ? (
                <div className="form-container">
                  <div>
                    <p> Please pick a task </p>
                  </div>
                  <div className="subcategory-dropDown">
                    <CategoryDetailDropdown
                      data={CategoryForm(userSelectedCategory?.MainCategory)}
                      subCategory={userSelectedCategory?.SubCategory}
                      setSelectedSubCategoryDetails={(value) => {
                        setUserSelectedCategory({
                          ...userSelectedCategory,
                          subCategoryDetails: value,
                        });
                      }}
                      value={userSelectedCategory?.subCategoryDetails}
                    />
                  </div>
                </div>
              ) : null}
            </div>
            <div className="flat-type-container">
              {userSelectedCategory.MainCategory === "Painting" ||
              (userSelectedCategory.MainCategory === "Cleaning" &&
                userSelectedCategory.SubCategory === "Full house cleaning") ||
              userSelectedCategory?.MainCategory === "Bathroom Cleaning" ? (
                <>
                  <div className="flat-type-label">
                    <p>Choose flat type : </p>
                  </div>

                  <FlatDropdown
                    data={FlatType}
                    setUserSubCategory={(value) =>
                      setUserSelectedCategory({
                        ...userSelectedCategory,
                        flatType: value,
                      })
                    }
                    value={userSelectedCategory?.flatType}
                  />
                </>
              ) : null}
            </div>
          {console.log("price details currently", priceDetails)}
            {Object.keys(priceDetails).length > 0 && priceDetails.price ? (
              <div className="form-container">
                <p> Cost : ₹{priceDetails?.price} </p>
              </div>
            ) : null}
          </>

          <div className="back-button-container">
            <button
              type="submit"
              className="next-button"
              disabled={validateJobDetailsError}
              onClick={() => setCurrentSection("personal-section")}
            >
              <IconContext.Provider value={{ color: "#588fe8", size: 20 }}>
                <BackIcon />
              </IconContext.Provider>
            </button>
            <button
              type="submit"
              className="next-button"
              disabled={validateJobDetailsError}
              onClick={() => validateJobSection()}
            >
              <IconContext.Provider value={{ color: "#588fe8", size: 20 }}>
                <IconComponent />
              </IconContext.Provider>
            </button>
          </div>
        </section>
      ) : currentSection === "personal-section" ? (
        <form
          className="modal-main"
          ref={modalRef}
          onSubmit={() => validatePersonalData()}
        >
          <div className="modal-header">
            <p className="modal-header-text">Let's get to know you</p>
          </div>
          <div className="form-container">
            <div className="form-label">
              <p className="form-label-text"> Please enter your full name </p>
            </div>
            <div className="form-input-container">
              <input
                placeholder="Please enter your full name"
                className="form-input"
                name="fulllName"
                type="text"
                required={true}
                value={personalData.fulllName}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-container">
            <div className="form-label">
              <p className="form-label-text"> How can we reach you ? </p>
            </div>
            <div className="form-input-container">
              <input
                placeholder="Please enter your phone number"
                className="form-input"
                name="phoneNumber"
                type="text"
                value={personalData.phoneNumber}
                onChange={handleChange}
                required={true}
              />
            </div>
          </div>
          <div className="form-container">
            <div className="form-label">
              <p className="form-label-text"> Please enter your email ID </p>
            </div>
            <div className="form-input-container">
              <input
                placeholder="Please enter your email ID"
                className="form-input"
                name="Emailaddress"
                type="email"
                onChange={handleChange}
                value={personalData?.Emailaddress}
                required={true}
              />
            </div>
          </div>

          <div className="form-container">
            <div className="form-label">
              <p className="form-label-text"> Please enter your pincode </p>
            </div>
            <div className="form-input-container">
              <input
                placeholder="Please enter your pincode"
                name="pincode"
                className="form-input"
                type="text"
                // value={personalData?.pincode}
                onChange={(event) => {
                  const validatePin = verifyPincode(event.target.value);
                  if (!validatePin) {
                    setValidationError({
                      ...validationError,
                      pincodeError: true,
                    });
                  } else {
                    setValidationError({
                      ...validationError,
                      pincodeError: false,
                    });
                    handleChange(event);
                  }
                }}
                required={true}
              />
            </div>
          </div>
          <div className="next-button-container">
            <button
              type="submit"
              className="next-button"
              disabled={validatePersonalDetailsError}
            >
              <IconContext.Provider value={{ color: "#588fe8", size: 20 }}>
                <IconComponent />
              </IconContext.Provider>
            </button>
          </div>
        </form>
      ) : currentSection === "slot-section" ? (
        <section
          className="modal-main"
          ref={modalRef}
          // onSubmit={() => validateBody()}
        >
          <div className="modal-header">
            <p className="modal-header-text">Choose your availability </p>
          </div>
          <div className="form-slot-container">
            <SlotDropdown
              setUserTimeSlot={(value) =>
                setUserSelectedCategory({
                  ...userSelectedCategory,
                  selectedSlot: value,
                })
              }
              data={slots(userSelectedCategory?.MainCategory)}
              value={userSelectedCategory?.selectedSlot}
            />
          </div>
          <div className="back-button-container">
            <button
              type="submit"
              className="next-button"
              disabled={validateJobDetailsError}
              onClick={() => setCurrentSection("job-section")}
            >
              <IconContext.Provider value={{ color: "#588fe8", size: 20 }}>
                <BackIcon />
              </IconContext.Provider>
            </button>

            <button
              type="submit"
              className="next-button"
              disabled={validatePersonalDetailsError}
              onClick={() => {
                if (userSelectedCategory?.selectedSlot.length > 0) {
                  // modelData();
                  setCurrentSection("address-section");
                } else {
                  alert("Please");
                }
              }}
            >
              <IconContext.Provider value={{ color: "#588fe8", size: 20 }}>
                <IconComponent />
              </IconContext.Provider>
            </button>
          </div>
        </section>
      ) : currentSection === "address-section" ? (
        <section
          className="modal-main"
          ref={modalRef}
          // onSubmit={() => validateBody()}
        >
          <div className="modal-header">
            <p className="modal-header-text">
              Just one last thing, we promise!{" "}
            </p>
          </div>
          <div className="form-container">
            <div className="form-label">
              <p className="form-label-text">
                {" "}
                Please enter your complete address{" "}
              </p>
            </div>
            <div className="form-input-container">
              <input
                placeholder="Please enter your address"
                className="form-input"
                name="address"
                type="text"
                onChange={(e) =>
                  setPersonalData({
                    ...personalData,
                    homeAddress: e.target.value,
                  })
                }
                required={true}
                value={personalData.homeAddress}
              />
            </div>
          </div>
          <div className="back-button-container">
            <button
              type="submit"
              className="next-button"
              disabled={validateJobDetailsError}
              onClick={() => setCurrentSection("slot-section")}
            >
              <IconContext.Provider value={{ color: "#588fe8", size: 20 }}>
                <BackIcon />
              </IconContext.Provider>
            </button>

            <button
              type="submit"
              className="next-button"
              // disabled={validatePersonalDetailsError}
              onClick={() => {
                if (userSelectedCategory?.selectedSlot.length > 0) {
                  modelData();
                  setCurrentSection("confirmation-section");
                }
              }}
            >
              <IconContext.Provider value={{ color: "#588fe8", size: 20 }}>
                <IconComponent />
              </IconContext.Provider>
            </button>
          </div>
        </section>
      ) : currentSection === "confirmation-section" ? (
        <section
          className="modal-main"
          ref={modalRef}
          // onSubmit={() => validateBody()}
        >
          <div className="confirm-header">
            <img
              src={confirm}
              alt={"order confirmed"}
              style={{ width: "30%", height: "30%" }}
            />
            <p className="modal-header-text">Yay! Your slot has been booked </p>
          </div>
          <div className="lineBreak"/>
          <br/>
          <div className="price-break">
            <tr className="row-item">
               <th>Cost Description</th>
               <th> Cost Total</th>
            </tr>
            <tr className="row-item">
              <td>Total price</td>
              <td>{priceDetails?.price}</td>
            </tr>
            <tr className="row-item">
              <td>Total tax</td>
              <td>{priceDetails?.tax}</td>
            </tr>
            <tr className="row-item">
              <td>Grand total</td>
              <td><b>{priceDetails?.total}</b></td>
            </tr>
          </div>

          <div className="next-button-container">
            <button
              type="submit"
              className="next-button"
              // disabled={validatePersonalDetailsError}
              onClick={() => {
                setUserSelectedCategory({
                  MainCategory: selectedCategory,
                  SubCategory: "",
                  subCategoryDetails: "",
                  flatType: "",
                  Qty: "",
                  selectedSlot: "",
                  addOns: "",
                });
                closeModal();
              }}
            >
              <IconContext.Provider value={{ color: "#588fe8", size: 20 }}>
                <IconComponent />
              </IconContext.Provider>
            </button>
          </div>
        </section>
      ) : null}
    </div>
  );
};

export default Modal;
